<template>
    <div class=" w-100">
        <transition name="slither">
            <div v-if="splash">
                <div class="container py-3 pantalla-principal text-center d-flex align-self-center">
                    <div class="align-self-center">
                        <span style="font-size: 38px;" class="mb-2 d-block">TarifApp</span>
                        <img src="/assets/img/logo.png" class="img-fluid logo-principal">
                        <div class="contenido-principal">
                            <h1 class="mt-5">Selecciona el equipo de climatización que mejor se adapte a cada espacio.</h1>
                            <hr>
                            <p>Con TarifApp obtendrás una mayor visibilidad de nuestros productos, y simplificarás procesos de asesoramiento y envío de presupuestos a tu cliente.</p>

                            <button type="button" class="btn bg-red btn-danger btn-lg" @click="splash = false">COMENZAR</button>

                        </div>
                    </div>
                </div>
                <!--<div class="barra-lateral"></div>
                <div class="btn-home d-flex cursor-pointer" @click="splash = false">
                    <div class="align-self-center text-center w-100">
                        <a href="#">
                            <i class="fas fa-arrow-right"></i>
                        </a>
                    </div>
                </div>-->
            </div>
        </transition>
        <div class="container-mob " v-if="!splash">
            <img src="/assets/img/logo.png" class="img-fluid logo-header mb-2">
            <div v-bind:class="flipped ? 'flip-container flipped': 'flip-container'">
                <div class="flipper">
                    <!--                INICIO SESION-->
                    <div class="front">

                        <div class="form-login mt-2">
                            <h2 class="mb-3" :class="{'intro-x':!flipped}">Identifícate</h2>
                            <div class="notification is-danger" :class="{'intro-x':!flipped}" v-if="error">
                                <p>{{ error }}</p>
                            </div>
                            <form autocomplete="off" @submit.prevent="login" method="post" :class="{'intro-x':!flipped}">
                                <div class="input-group">
                                    <span class="input-group-text" id="basic-addon1"><i class="fas fa-user"></i></span>
                                    <input type="text" class="form-control" placeholder="Email" aria-label="Usuario" aria-describedby="basic-addon1" id="usuario" v-model="form.username">
                                </div>
                                <div class="input-group">
                                    <span class="input-group-text" id="basic-addon2"><i class="fas fa-unlock-alt"></i></span>
                                    <input type="password" class="form-control" placeholder="Contraseña" aria-label="Contraseña" aria-describedby="basic-addon2" id="password" v-model="form.password">
                                </div>
                                <div class="text-end enlace-form pt-3">
                                    <a href="#" v-on:click="flipped=true">Recuperar contraseña</a>
                                </div>
                                <div class="text-center mt-5">
                                    <button type="button" class="btn-form" @click="login">ENTRAR</button>
                                </div>
                                <div class="text-center enlace-form pt-3">
                                    <router-link to="/registro">¿Aún no estás registrado?</router-link>
                                </div>

                            </form>
                        </div>
                    </div>
                    <!--                OLVIDASTE CONTRASEÑA-->
                    <div class="back">
                        <div class="form-login mt-5">
                            <h2 class="mb-3" :class="{'intro-x':!flipped}">Restablecer Contraseña</h2>
                            <div class="notification text-danger" :class="{'intro-x':!flipped}" v-if="error">
                                <p>{{ error }}</p>
                            </div>
                            <div v-if="resetOK" class="notification is-valid" role="alert">
                                Link para restablecer contraseña enviado.
                            </div>
                            <div v-else>
                                <div class="text-lg" :class="{'intro-x':flipped}">Introduce tu email para solicitar el cambio de contraseña.</div>
                                <form autocomplete="off" @submit.prevent="reset" method="post" :class="{'intro-x':!flipped}">
                                    <div class="input-group">
                                        <span class="input-group-text"><i class="fas fa-user"></i></span>
                                        <input type="text" class="form-control" placeholder="Email" aria-label="Usuario" v-model="frmReset.email">
                                    </div>

                                    <div class="mt-5 text-center" :class="{'intro-x':flipped}">
                                        <button type="button" @click="reset" class="btn-form">
                                            <template v-if="!requestState">Restablecer</template>
                                            <animated-icon v-else icon="oval" color="white" class="w-5 h-5 block mx-auto"></animated-icon>
                                        </button>
                                        <div class="text-center enlace-form pt-2">
                                            <a href="#" v-on:click="flipped=false">Volver</a>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            form: {
                username: '',
                password: '',
                remember: false
            },
            frmReset: {
                email: '',
            },
            flipped: false,
            requestState: false,
            resetOK: false,
            error: '',
            splash: true,
        }
    },
    methods: {
        login() {
            this.$store
            .dispatch("retrieveToken", {
                username: this.form.username,
                password: this.form.password
            })
            .then(response => {
                this.$router.push({name: "dashboard"});
            })
            .catch(error => {
                this.error = error.response.data;
            });
        },

        reset() {
            this.$store
            .dispatch("resetPass", {
                username: this.frmReset.email,
            })
            .then(response => {
                this.resetOK = true;
            })
            .catch(error => {
                this.error = error.response.data.errors.email[0];
            });
        }

    }
};
</script>

<style>
.logo-header {
    max-width: 150px;
}

.input-group-text {
    background: #FAFAFA;
    border: none;
    border-radius: 0px;
    padding-top: 20px;
    padding-bottom: 20px;
    color: #989898;
    width: 40px;
    margin-left: auto;
    margin-right: auto;
}

.input-group > .form-control, .input-group > .form-select {
    background: #FAFAFA;
    border: none;
    border-radius: 0px;
}

.input-group:last-child {
    border-top: 1px solid #EDEDED;
}

.input-group input:focus {
    box-shadow: none;
}

.input-group input::placeholder {
    font-size: 14px;
}

.btn-form {
    background: #F9423E;
    color: white;
    border-radius: 100px;
    text-align: center;
    padding: 5px 40px;
    border: 0px;
    margin-left: auto;
    margin-right: auto;
}

.enlace-form a {
    color: #F9423E !important;
    font-size: 15px !important;
    text-decoration: none;
}
</style>

<style type="text/css" scoped>
i.frontFlipBtn,
i.backFlipBtn {
    position: absolute;
    right: 20px;
    top: 20px;
    color: #FFFFFF;
}

i.backFlipBtn {
    -webkit-transform: rotateY(-180deg);
    -moz-transform: rotateY(-180deg);
    -o-transform: rotateY(-180deg);
    -ms-transform: rotateY(-180deg);
    transform: rotateY(-180deg);
}

.flip-container {
    -webkit-perspective: 1000;
    -moz-perspective: 1000;
    -o-perspective: 1000;
    perspective: 1000;
}

.flip-container {
    min-height: 120px;
}

.flipper {
    -moz-transform: perspective(1000px);
    -moz-transform-style: preserve-3d;
    position: relative;
}

.front,
.back {
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -o-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition: 0.6s;
    -webkit-transform-style: preserve-3d;
    -moz-transition: 0.6s;
    -moz-transform-style: preserve-3d;
    -o-transition: 0.6s;
    -o-transform-style: preserve-3d;
    -ms-transition: 0.6s;
    -ms-transform-style: preserve-3d;
    transition: 0.6s;
    transform-style: preserve-3d;
    top: 0;
    left: 0;
    width: 100%;
}

.back {
    -webkit-transform: rotateY(-180deg);
    -moz-transform: rotateY(-180deg);
    -o-transform: rotateY(-180deg);
    -ms-transform: rotateY(-180deg);
    transform: rotateY(-180deg);
    position: absolute;
}

.flip-container.flipped .back {
    -webkit-transform: rotateY(0deg);
    -moz-transform: rotateY(0deg);
    -o-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    transform: rotateY(0deg);
}

.flip-container.flipped .front {
    -webkit-transform: rotateY(180deg);
    -moz-transform: rotateY(180deg);
    -o-transform: rotateY(180deg);
    -ms-transform: rotateY(180deg);
    transform: rotateY(180deg);
}

.front {
    z-index: 2;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
